var merge = require('lodash.merge');
export function hashFromString(str, hash) {
    if (hash === void 0) { hash = {}; }
    var key = '';
    var exploded;
    if (str.length === 0) {
        return {};
    }
    exploded = str.split('.');
    key = exploded.shift() || '';
    str = exploded.join('.');
    if (str === '') {
        hash[key] = null;
    }
    else {
        hash[key] = hashFromString(str, {});
    }
    return hash;
}
export function hashFromStrings(strings) {
    return strings
        .map(function (s) { return hashFromString(s); })
        .reduce(function (acc, val) { return merge(acc, val); }, {});
}
function formatRec(obj, fieldsConfig, curIndent, level, indentIncrement) {
    if (level === void 0) { level = 0; }
    if (indentIncrement === void 0) { indentIncrement = 2; }
    var newIndent = curIndent + level * indentIncrement;
    var space = ' '.repeat(newIndent);
    var fields = [];
    for (var _i = 0, _a = Object.entries(obj); _i < _a.length; _i++) {
        var _b = _a[_i], k = _b[0], v = _b[1];
        if (k.startsWith('on:')) {
            k = k.replace('on:', '... on ');
        }
        else if (k.startsWith('fragment:')) {
            var fragmentName = k.replace('fragment:', '');
            k = "...".concat(fragmentName);
        }
        var res = v === null
            ? "".concat(space).concat(k)
            : "".concat(space).concat(k, " {\n").concat(formatRec(v, fieldsConfig, curIndent, level + 1), "\n").concat(space, "}");
        fields.push(res);
    }
    return fields.join('\n');
}
export default function format(fields, fieldsConfig, startIndent) {
    if (fieldsConfig === void 0) { fieldsConfig = { fragmentDefinitions: {} }; }
    if (startIndent === void 0) { startIndent = 6; }
    var allFragments = '';
    var fragmentDefinitions = fieldsConfig.fragmentDefinitions;
    var space = ' '.repeat(startIndent);
    for (var _i = 0, _a = Object.entries(fragmentDefinitions); _i < _a.length; _i++) {
        var _b = _a[_i], name_1 = _b[0], value = _b[1];
        if (value.on) {
            allFragments += "".concat(space, "fragment ").concat(name_1, " on ").concat(value.on, " {\n").concat(formatRec(hashFromStrings(value.fragment), { fragmentDefinitions: {} }, startIndent + 2), "\n").concat(space, "}\n");
        }
        else {
            allFragments += value.fragment;
        }
    }
    return {
        fragments: allFragments,
        fields: formatRec(hashFromStrings(fields), fieldsConfig, startIndent),
    };
}
//# sourceMappingURL=graphFormatter.js.map